// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class FinishedRegistrationDto extends APIModel {
    /**
    * Worker identifier
    */
    id: number;
    /**
    * Worker name
    */
    firstName: string;
    /**
    * User Identifier
    */
    identifier: string;
    /**
    * True, if worker has valid PIN
    */
    hasValidPin: boolean;

    constructor(options?: APIModelOptions) {
        super(FinishedRegistrationDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "firstName", type: "string" },
            { name: "identifier", type: "string" },
            { name: "hasValidPin", type: "boolean" }
        ];
    }
}




